// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"73554b0e","288":"6ef58d13","453":"b95fc509","560":"4596146b","573":"94344439","699":"b54e8205","727":"15894b8a","767":"0d30b49f","771":"00417acd","778":"fcf7f436","918":"6029e7bc","961":"6f145d24"}[chunkId] + ".chunk.js";
};